function NoSms() {
  return (
    <div className="no-sms-page ">
      <div className="no-sms-paragraph">
        სადაზღვევო კომპანია „იმედი ელ“ (სს „სადაზღვევო კომპანია იმედი ელ“; ს/კ
        204919008) თავისი 24-წლიანი ისტორიით პირველი სადაზღვევო კოპანიაა ქართულ
        ბაზარზე, რომელიც უმთავრესად ჯანმრთელობისა და მასთან დაკავშირებული
        რისკების დაზღვევაზეა ორიენტირებული. ჩვენ ვართ საქართველოს ჯანდაცვის
        ჯგუფის წევრი, ეკოსისტემის, რომელიც გთავაზობთ სამედიცინო მომსახურებებისა
        და პროდუქტების სრულ სპექტრს.
      </div>
      <div className="no-sms-paragraph">
        თუ გაქვთ სურვილი, რომ 2024 წლის 1 მარტიდან მიიღოთ ჩვენი სპეციალური
        შეთავაზებები (SMS მარკეტინგის გზით), გთხოვთ, გამოაგზავნოთ ციფრი 1 თქვენი
        მობილური ტელეფონის ნომრიდან ჩვენს სპეციალურ მოკლე SMS ნომერზე - 91443.
      </div>
      <div className="no-sms-paragraph">
        შეთავაზებაზე თანხმობა არ გავალდებულებთ ჩვენი მომსახურებით სარგებლობას.
      </div>
      <div className="no-sms-paragraph">
        გაცნობებთ, რომ ჩვენი შეთავაზებების მიღებაზე თანხმობის გაცხადების შემდეგ,
        თქვენ ნებისმიერ დროს გექნებათ თანხმობის გამოხმობის უფლება შემდეგი
        ქვემოთჩამოთვლილი ნებისმიერი/რომელიმე გზითა და საშუალებით:
      </div>
      <ul className="no-sms-ul">
        <li>
          მოკლე SMS ნომერზე (91443) მოკლე ტექსტური შეტყობინების გამოგზავნით,
          ნებისმიერი ტექსტით (მათ შორის: NO, NO SMS, OFF, SMS OFF ან სხვ.),
          გარდა „1“-სა, რაც მიიჩნევა თანხმობად ჩვენი მარკეტინგული SMS-ების
          მისაღებად;
        </li>
        <li>
          ან ჩვენს მიერ პირდაპირი მარკეტინგის განხორციელებისას, კონკრეტულ მოკლე
          ტექსტურ შეტყობინებაში მითითებული შესაბამისი დამატებითი მექანიზმის
          საშუალებით/გამოყენებით;
        </li>
        <li>
          ან შესაბამისი წერილობითი მომართვით ჩვენი ელექტრონული ფოსტის
          მისამართზე: <a href="info@imedil.ge">info@imedil.ge</a>
        </li>
      </ul>
    </div>
  );
}

export default NoSms;
